import { render, staticRenderFns } from "./jurisdiction.vue?vue&type=template&id=4c40d4e9&scoped=true&"
import script from "./jurisdiction.vue?vue&type=script&lang=js&"
export * from "./jurisdiction.vue?vue&type=script&lang=js&"
import style0 from "../../../assets/css/common/nav.less?vue&type=style&index=0&id=4c40d4e9&scoped=true&lang=less&"
import style1 from "../../../assets/css/common/table.less?vue&type=style&index=1&id=4c40d4e9&scoped=true&lang=less&"
import style2 from "./jurisdiction.vue?vue&type=style&index=2&id=4c40d4e9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c40d4e9",
  null
  
)

export default component.exports